import * as types from './types'
console.log('-------------------------------------')
console.log(types)
export default {
  hideLoading: ({ commit }) => {
    commit(types.HIDE_LOADING)
  },
  showLoading: ({ commit }) => {
    commit(types.SHOW_LOADING)
  },
  setRecommend: ({ commit }) => {
    commit(types.SET_RECOMMEND)
  },
  setUserInfo:({ commit }) => {
    commit(types.SET_USERINFO)
  },
  setSToken:({ commit }) => {
    commit(types.SET_TOKEN_SCOKET)
  },
  setCode:({ commit }) => {
    commit(types.SET_CODE)
  },
  SET_WX_ALERT:({commit}) =>{
    commit(types.SET_WX_ALERT)
  },
  TIME_OBJ:({commit}) =>{
    commit(types.TIME_OBJ)
  },
  SET_USERLIST:({commit}) =>{
    commit(types.SET_USERLIST)
  },
  SET_LOGIN_OBJ:({commit}) =>{
    commit(types.SET_LOGIN_OBJ)
  },

  SET_APP_FLAG:({commit}) =>{
    commit(types.SET_APP_FLAG)
  },
  SET_MJB:({commit}) =>{
    commit(types.SET_MJB)
  },
  SET_PID:({commit}) =>{
    commit(types.SET_PID)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js